import { useMemo } from "react";
import { useFlags } from "@/hooks/useFeatureFlags";
import { useCanViewBeneficiariesBool, useCanViewGrpCommissionBool } from "@/hooks/useCapabilities";
import type { Path } from "@/router";

export function useShowPersonGrpBenefitsTab(): boolean {
  const flags = useFlags();
  const canViewGrpCommission = useCanViewGrpCommissionBool();

  return !!flags["commission-grp-platform"] && canViewGrpCommission;
}

export function useCanAccessPersonBenefits(): boolean {
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  return canViewBeneficiaries || showGrpTab;
}

export function usePersonBenefitsDefaultTab(pgaId: string): Path {
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  return useMemo(() => {
    if (canViewBeneficiaries) {
      return `/people/${pgaId}/benefits/beneficiaries` as Path;
    }

    if (showGrpTab) {
      return `/people/${pgaId}/benefits/grp` as Path;
    }

    return `/people/${pgaId}/benefits/beneficiaries` as Path;
  }, [canViewBeneficiaries, pgaId, showGrpTab]);
}
